import { Link } from "wouter";

export const Button = ({
	type = "button",
	content = "Content Default",
	width,
	buttonRoute,
	clickHandler,
}) => {
	return (
		<button
			className={type}
			style={{ width: width }}
			onClick={clickHandler && clickHandler}
		>
			{!buttonRoute && content}
			{buttonRoute && (
				<Link href={buttonRoute}>
					{
						// eslint-disable-next-line jsx-a11y/anchor-is-valid
						<a className="remove-link-styles">{content}</a>
					}
				</Link>
			)}
		</button>
	);
};
